import i18next from './i18n'

export enum BrowserLanguage {
    German = 'de',
    English = 'en',
    French = 'fr',
    Dutch = 'nl',
}

export const useBrowserLanguage = () => {
    switch (i18next.language.split("-")[0].toLowerCase()) {
        case "de": return BrowserLanguage.German
        case "en": return BrowserLanguage.English
        case "fr": return BrowserLanguage.French
        case "nl": return BrowserLanguage.Dutch
        default: return BrowserLanguage.English
    }
}